module.exports = __webpack_public_path__ + "static/img/vhost-sql.5fa45d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/vhost-sql.png
// module id = N0pz
// module chunks = 1